import type {
  ScheduledProductRestrictionDataImportType as Type,
  ScheduledProductRestrictionDataImportStatus as Status,
} from 'contracts/restricted-products/scheduled-data-imports';

export const getStatusName = (status: Status) => {
  switch (status) {
    case 'pending':
      return 'Em fila de processamento';
    case 'processing':
      return 'Processando importação';
    case 'finished':
      return 'Importação concluída com sucesso';
    case 'canceled':
      return 'Importação cancelada pelo usuário';
    case 'failed':
      return 'Falha de importação';
  }
};

export const getTypeName = (type: Type) => {
  switch (type) {
    case 'blocked-products':
      return 'Importação de Produtos Restritos';
    case 'materials':
      return 'Importação automática da planilha diária do SAP';
    case 'sale-movements':
      return 'Importação de movimentos de venda';
  }
};
